<template>
	<div id="floatingCenterAdvance">
		<div id="multiLineView" class="d-flex" v-if="settings.multiLineView">
			<div>
				<nk-image :modelValue="imageValue" :options="componentOptions.image"></nk-image>
			</div>
			<div style="line-height: 1.4; font-weight: bold;" class="d-flex flex-column justify-content-center text-right mr-2 flex-grow-1">
				<div class="d-flex">
					<span style="font-size: 16px;" class="text-gray-detail my-n1">{{ settings.data.name }}</span>
					<nk-popover class="mr-1" :options="componentOptions.popover"></nk-popover>
				</div>
				<span v-if="settings.data.phone" class="text-gray-label">{{ $t('center.f.phone') }}: {{ settings.data.phone }}</span>
				<span class="text-gray-label">{{ $t('center.f.balance') }}: {{ balancePlusText }}</span>
			</div>
		</div>
		<div class="nk-label-sa advance-floating" v-else>
			<div>{{ settings.data.name }}</div>
			<div v-if="settings.advance" :class="['balance', textColor]">
				<b><span>{{ $t('account.balance') }}: </span><span>{{ balancePlusText }}</span></b>
			</div>
			<div v-if="settings.advance">
				<nk-popover v-show="checkFloatingBalanceAccess" :options="componentOptions.popover"></nk-popover>
			</div>
		</div>
		<div ref="popContent" style="display: none">
			<div class="pop-body">
				<div> {{ $t('center.f.accountingCode') }}: {{ settings.data.accountingCode?.toString() }}</div>
				<div> {{ $t('center.f.name') }}: {{ settings.data.name }}</div>
				<div v-if="settings.data.phone"> {{ $t('center.f.phone') }}: {{ settings.data.phone }}</div>
				<div v-if="settings.data.address"> {{ $t('center.f.address') }}: {{ settings.data.address }}</div>
				<div> {{ $t('AccountNatures.debtorremaining') }}: {{ !settings.data.balanceRestricted ? formatPrice(settings.data.totalDebit) : '***' }}</div>
				<div> {{ $t('AccountNatures.creditorremaining') }}: {{ !settings.data.balanceRestricted ? formatPrice(settings.data.totalCredit) : '***' }}</div>
				<div> {{ $t(`sale.factor.last-${this.factorType.toLowerCase()}`) }}: <span v-html="lastFactor"></span></div>
				<ul class="toolbar">
					<li><a href="javascript:void(0)" @click="showFloatingDetail()"><i class="fad fa-edit"></i></a></li>
					<li><a href="javascript:void(0)" @click="loadFloatingData()"><i class="fad fa-redo"></i></a></li>
					<li><a href="javascript:void(0)" @click="turnOver()"><i class="fas fa-coins"></i></a></li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
	import _ from 'lodash'
	import $ from 'jquery'
	import { defineAsyncComponent } from 'vue'
	import { post } from '~/plugins/nikan-api'
	import Endpoints from '@nikan/endpoints'
	import tv from '@nikan/text-visualizer'
	import { mapState, mapGetters } from 'vuex'
	import CenterModify from '~/views/floating-centers/modify'
	import PersianDate from 'persian-date'


	export default {
		props: ['modelValue', 'options'],
		data() {
			return {
				componentOptions: {
					image: {
						width: 45,
						height: 45,
						class: 'user-profile-circle',
						defaultImage: ''
					},
					popover: {
						title: this.$t('center.center-info'),
						contentElement: '',
						//preventCloseDropdown: false
					}
				},
				lastFactor: '...'
			}
		},
		mounted() {
			this.componentOptions.popover.contentElement = $(this.$refs.popContent)
			this.fillPhoneAndAddress()
		},
		computed: {
			...mapState('appContext', {
				status: state => state
			}),
			...mapGetters({
				getCenterImage: 'floatingCenters/getCenterProfile',
				checkFloatingBalanceAccess: 'appContext/checkAccessFloatingCentersBalanceObserve',
				getAccountsByIds: 'accounts/getByIds',
			}),
			imageValue() {
				return this.getCenterImage(this.settings.data)
			},
			settings() {
				const data = this.options?.data || this.$props.params?.options?.data || {}
				return Object.assign({ multiLineView: false }, this.options || this.$props.params.options, { data: data })
			},
			type() {
				return getType(this.settings.type, this.settings.format)
			},
			factorType() {
				return this.settings.factorType || 'sale'
			},
			textColor() {
				let relatedAccounts = this.getAccountsByIds(this.settings.data.relatedAccountIds)

				if (relatedAccounts.every(x => x.accountNature.includes('Debtor')) && this.modelValue > 0)
					return 'text-red'

				if (relatedAccounts.every(x => x.accountNature.includes('Creditor')) && this.modelValue < 0)
					return 'text-red'

				return 'text-info'
			},
			balancePlusText() {
				return this.checkFloatingBalanceAccess && !this.settings.data.balanceRestricted ? this.formatPrice(this.settings.data.balance) + ' ' + this.balanceType() : '***'
			}
		},
		methods: {
			formatPrice(price) {
				return String(tv(Math.abs(price), { type: 'price' })).toLocaleDigits()
			},
			fillPhoneAndAddress() {
				var center = this.settings.data
				center.metaDatas?.map(meta => {

					if (meta.metaDataSchema.systemField === 'Center_Phone')
						center.phone = meta.value

					if (meta.metaDataSchema.systemField === 'Center_Address')
						center.address = meta.value
				})
			},
			balanceType() {
				return this.settings.data.balance < 0 ? this.$t('account.short-debit') : this.settings.data.balance > 0 ? this.$t('account.short-credit') : ''
			},
			showFloatingDetail() {
				_.head(document.getElementsByTagName('body')).force_dropdown_close = true
				var centerInfo = {
					nodeData: this.settings.data,
					parentData: this.settings.data.parent ? this.settings.data.parent : null,
					state: 'edit'
				}

				this.showModal({ component: CenterModify, data: centerInfo })
					.then((result) => {
					})
					.catch(() => {

					})
			},
			loadFloatingData() {
				var wait = this.$wait(this.$refs.popContent.closest('.popover-body'), { size: 'small' })
				var request = {
					floatingCenterId: this.settings.data.id,
					type: this.factorType
				}
				post(Endpoints.getUrl('sale.factor.get-floating-center-extra-data'), request)
					.then(result => {
						wait.end()
						var lastFactor = result.data.lastFactor
						if (!lastFactor)
							this.lastFactor = this.$t('sale.factor.m.factor-not-found')
						else {
							var date = new PersianDate(lastFactor.date).format('YYYY' + '/' + 'MM' + '/' + 'DD')
							this.lastFactor = `<br/>${this.$t('sale.factor.f.code')}: ${String(lastFactor.code).toLocaleDigits()}`
							this.lastFactor += `<br/>${this.$t('sale.factor.f.date')}: ${String(date).toLocaleDigits()}`
							this.lastFactor += `<br/>${this.$t('sale.factor.f.totalPayableAmount')}: ${this.formatPrice(lastFactor.totalPayableAmount)} `
						}
					})
					.catch(() => {
						wait.end()
					})
			},
			turnOver() {
				_.head(document.getElementsByTagName('body')).force_dropdown_close = true
				this.showModal({
					component: defineAsyncComponent(() => import('~/views/reports/turn-over.vue')),
					data: null,
					options: {
						filter: { centers: [[this.settings.data]], level: 3, centerInAllLevels: true },
					},
				})
					.then((result) => { })
					.catch((err) => { })
			},
		}
	}
</script>
<style>
	.text-gray-label {
		color: #8e8e8e !important;
	}

	.text-gray-detail {
		color: #424242 !important;
	}

	/* tr.grid-row-selected .advance-floating .balance.text-green {
    color: #b3ffc4 !important;
  }

  tr.grid-row-selected .advance-floating .balance.text-red {
    color: #ffcece !important;
  }

  tr.grid-row-selected .advance-floating a {
    color: #d0e7ff !important;
  } */

	.nk-label-sa.advance-floating {
		display: flex;
	}

	.nk-label-sa.advance-floating>div {
		margin-left: 5px;
	}

	.pop-body>div {
		padding: 3px;
		border-bottom: 1px dashed #ccc;
	}

	.pop-body>div:last-of-type {
		padding: 3px;
		border-bottom: none;
	}
</style>
